import yn from "yn";

// The multi-agent switching UI — the composer's agent switcher and the
// transcript's hand-off divider — is gated behind the VITE_MULTI_AGENT_ENABLED
// build flag so it ships per environment (manifold stage first). When off,
// conversations render single-agent: no switcher and no switch dividers. The
// per-turn agent label is unaffected; it is baseline turn attribution, not part
// of this gate.
export const useMultiAgentEnabled = (): boolean =>
  yn(import.meta.env.VITE_MULTI_AGENT_ENABLED, { default: false });
